import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'

import PropTypes from 'prop-types'
import moment from 'moment'

import getByPath from 'lodash/get'

import MaterialTimePicker from 'material-ui/TimePicker'

import PlacesAutocomplete from './PlacesAutocomplete'

import { TextEditor, TextInput } from '../UI'
import { get15MinsIntervals } from './../../libs/utils'

import { defaultDate } from './index'

class Other extends Component {
  static propTypes = {
    onFormFieldChange: PropTypes.func.isRequired,
    onLocationSelect: PropTypes.func.isRequired,
    onPlaceSelect: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    placeInputProps: PropTypes.object,
    locationInputProps: PropTypes.object,
    locationOptions: PropTypes.object,
    dates: PropTypes.array,
    t: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      date: moment().startOf('day'),
      time: moment().startOf('day'),
      duration: 15,
      place: '',
      type: 'Info'
    }

    this.result = get15MinsIntervals()
  }

  onDateChange(date) {
    this.setState(
      {
        date: moment(date)
      },
      () => {
        this.checkDates()
      }
    )
  }

  checkDates() {
    if (this.state.date && this.state.time && this.state.duration) {
      const startDate = this.state.date.clone().set({
        hours: this.state.time.hours(),
        minutes: this.state.time.minutes()
      })

      const endDate = startDate.clone().add(this.state.duration, 'minutes')

      this.props.onFormFieldChange('startDate', startDate.toISOString())
      this.props.onFormFieldChange('endDate', endDate.toISOString())
    }
  }

  render() {
    const {
      dates,
      locationInputProps,
      locationOptions,
      onFormFieldChange,
      onLocationSelect,
      onPlaceSelect,
      placeInputProps,
      t,
      form
    } = this.props

    return (
      <div id="other-form" className="event__form--hidden">
        <div className="form-horizontal event__form-container">
          <h2 className="event__form-group-label">{t('places')}</h2>

          <div className="form-group">
            <label htmlFor="info-place" className="event__form-label col-md-3 control-label">
              {t('place_label')}
            </label>
            <PlacesAutocomplete inputProps={placeInputProps} onSelect={(place, placeId) => onPlaceSelect(place, placeId)} />
          </div>

          <TextInput
            label={t('link__label')}
            labelClass="event__form-label col-md-3 control-label"
            inputWrapperClass="col-md-9"
            isGroup={true}
            id="contentPOIs[0].website"
            extraClass="form-control event__form-input"
            initialValue={getByPath(form, 'contentPOIs[0].website', '')}
            placeholder={t('link__placeholder')}
            onChangeExternal={(id, value) => onFormFieldChange(id, value)}
          />

          <div className="form-group mb-0">
            <label htmlFor="info-location" className="event__form-label col-md-3 control-label">
              {t('location_label')}
            </label>
            <PlacesAutocomplete id="info-location" onSelect={onLocationSelect} options={locationOptions} inputProps={locationInputProps} />
          </div>
        </div>

        <hr />

        <div className="form-horizontal event__form-container">
          <h2 className="event__form-group-label">{t('description_label')}</h2>
          <div className="event__example-container">
            <i className="icon-flag event__example-icon" /> <span className="event__example-text">{t('description_example')}</span>
          </div>
          <TextEditor
              id="editor"
              value={form.description}
              placeholder={t('description_placeholder')}
              onChange={(content, delta, source, editor) => {
                onFormFieldChange('description', content)
              }}
          />
                  
        </div>

        <hr />

        <div className="form-horizontal event__form-container">
          <h2 className="event__form-group-label">{t('time')}</h2>
          <div className="form-group">
            <label htmlFor="otherDateDay" className="event__form-label col-md-3 control-label">
              {t('date_day_label')}
            </label>
            <div className="col-md-4">
              <select
                id="otherDateDay"
                className="form-control event__form-input"
                value={this.state.date && this.state.date.toISOString()}
                onChange={e => this.onDateChange(e.target.value)}
              >
                <option value="" disabled hidden>
                  {t('date_day_placeholder')}
                </option>
                {dates.map((day, i) => (
                  <option
                    key={i}
                    value={
                      day.dayOfTrip ||
                      defaultDate
                        .clone()
                        .add(i, 'days')
                        .toISOString()
                    }
                  >
                    {day.dayOfTrip ? `${moment(day.dayOfTrip).format('MMM D')} / ` : ''}
                    {day.title}
                  </option>
                ))}
              </select>
            </div>

            <label htmlFor="activityStartTime" className="event__form-label col-md-2 control-label">
              {t('start_time_label')}
            </label>
            <div className="col-md-3">
              <MaterialTimePicker
                id="infoStartTime"
                className="material-time-picker"
                format="24hr"
                value={this.state.time && this.state.time.toDate()}
                onChange={(_, value) => {
                  this.setState(
                    {
                      time: moment(value)
                    },
                    () => {
                      this.checkDates()
                    }
                  )
                }}
              />
            </div>
          </div>
          <div className="form-group mb-0">
            <label htmlFor="otherDuration" className="event__form-label col-md-3 control-label">
              {t('duration_label')}
            </label>
            <div className="col-md-4">
              <select
                id="otherDuration"
                className="form-control event__form-input"
                value={this.state.duration}
                onChange={e => this.setState({ duration: e.target.value }, () => this.checkDates())}
              >
                <option value="">{t('duration_placeholder')}</option>
                {this.result.map(el => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  translate('event', {
    withRef: true
  })
)(Other)



// WEBPACK FOOTER //
// src/components/Event/Info.js